export const V_TYPES = {
    arr: '[object Array]',
    fun:'[object Function]'
}